"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/** This is a placeholder, not real render in dom */
var Option = function Option() {
  return null;
};

Option.isSelectOption = true;
var _default = Option;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-select/lib/Option.js
// module id = 673
// module chunks = 0